"use strict";
angular.module("planCommandMonitorAddFunctionRouterModule", ['planCommandMonitorAddFunctionModule', 'planCommandMonitorAreaHotspotsModule', 'planCommandMonitorManuscriptDiffusionModule', 'planCommandMonitorSelectedTopicModule'])
    .config(["$stateProvider", function($stateProvider) {
        $stateProvider
            .state("front.planningresource.commandMonitor.addfunction", {
                url: '/addfunction',
                views: {
                    'main@front.planningresource.commandMonitor': {
                        templateUrl: './planningResource/commandMonitor/addFunction/addFunction_tpl.html',
                        controller: 'planCommandMonitorAddFunctionCtrl'
                    }
                }
            })
            .state("front.planningresource.commandMonitor.addfunction.areahotspots", {
                url: '/areahotspots?sceneid&addflg&userroleid',
                views: {
                    'main@front.planningresource.commandMonitor': {
                        templateUrl: './planningResource/commandMonitor/addFunction/areaHotspots/areaHotspots_tpl.html',
                        controller: 'planCommandMonitorAreaHotspotsCtrl'
                    }
                }
            })
            .state("front.planningresource.commandMonitor.addfunction.manuscriptdiffusion", {
                url: '/manuscriptdiffusion?sceneid&addflg&userroleid',
                views: {
                    'main@front.planningresource.commandMonitor': {
                        templateUrl: './planningResource/commandMonitor/addFunction/manuscriptDiffusion/manuscriptDiffusion_tpl.html',
                        controller: 'planCommandMonitorManuscriptDiffusionCtrl'
                    }
                }
            })
            .state("front.planningresource.commandMonitor.addfunction.selectedtopic", {
                url: '/selectedtopic?sceneid&addflg&userroleid',
                views: {
                    'main@front.planningresource.commandMonitor': {
                        templateUrl: './planningResource/commandMonitor/addFunction/selectedTopic/selectedTopic_tpl.html',
                        controller: 'planCommandMonitorSelectedTopicCtrl'
                    }
                }
            });
    }]);
